import SvgIcon from '@mui/material/SvgIcon';
import classNames from 'classnames';

import { useStyles } from './Reactions.styles';
import { ReactionProps } from './Reactions.types';

export const ThumbsUp = ({
  size = 'default',
  color = 'secondary',
}: ReactionProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <path
        d="M10.193 17.2551C6.74257 17.2551 4.95703 15.9946 4.47968 13.4371C3.91132 10.611 5.94531 8.38205 6.74257 7.70315C7.58554 6.98557 8.37538 5.85471 8.29179 4.04729C8.18906 1.82228 10.5508 1.50002 11.2668 3.58479C11.8715 5.34533 10.4777 7.57307 11.3531 8.5051C11.6666 8.80502 12.5484 8.89857 12.5484 8.89857C12.9714 8.95906 13.7046 8.97082 13.9724 8.97884C15.7248 9.35375 14.428 10.4241 14.5043 11.3699C14.8691 12.5641 15.0538 17.2551 10.193 17.2551Z"
        fill="url(#paint0_radial_4706_230590)"
      />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7465 7.6998C7.58799 6.98205 8.37525 5.8519 8.29179 4.04729C8.18906 1.82228 10.5508 1.50002 11.2668 3.58479C11.56 4.43856 11.3833 5.4022 11.2233 6.27466C11.0549 7.19253 10.9051 8.00948 11.3405 8.4914C11.3449 8.49595 11.3492 8.50051 11.3535 8.50507C11.952 9.14247 12.0604 9.40176 12.0534 9.4957C12.1159 9.48307 12.2393 9.48091 12.468 9.51445C14.4561 9.80541 14.4661 10.1898 14.4864 10.9684C14.4896 11.092 14.493 11.2254 14.5047 11.3699C14.8695 12.5641 15.1167 17.2551 10.1934 17.2551H10.193C6.74257 17.2551 4.95703 15.9945 4.47968 13.4371C3.91132 10.6109 5.94531 8.38203 6.74257 7.70312C6.74388 7.70201 6.74519 7.7009 6.7465 7.6998Z"
        fill="url(#paint1_radial_4706_230590)"
      />
      <g filter="url(#filter0_f_4706_230590)">
        <path
          d="M5.68164 12.989C10.0695 13.2558 8.16758 16.7683 11.0359 16.2683C11.7742 16.1394 11.7922 10.4554 11.7723 9.3503C10.5047 9.06124 10.8328 9.94092 10.8328 9.94092C10.8328 9.94092 10.0152 12.8468 5.68164 12.9894V12.989Z"
          fill="url(#paint2_radial_4706_230590)"
        />
      </g>
      <path
        d="M8.09454 15.3782C7.89376 16.4469 8.72384 17.2219 9.80782 17.1336C11.0754 17.0305 11.7637 17.1739 11.9645 16.1051C12.1652 15.0364 11.4617 14.0075 10.393 13.8067C9.32423 13.6059 8.29532 14.3094 8.09454 15.3782Z"
        fill="url(#paint3_radial_4706_230590)"
      />
      <path
        d="M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z"
        fill="url(#paint4_radial_4706_230590)"
      />
      <path
        d="M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z"
        fill="url(#paint5_radial_4706_230590)"
      />
      <path
        d="M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z"
        fill="url(#paint6_radial_4706_230590)"
      />
      <path
        d="M10.5638 14.5537C9.52983 14.6558 9.24897 16.4126 10.1951 16.7919C11.4603 17.2991 13.5431 17.354 14.2986 16.8533C15.0541 16.3526 15.1935 15.0997 14.1958 14.7424C13.1978 14.3851 11.5978 14.4517 10.5638 14.5537Z"
        fill="url(#paint7_radial_4706_230590)"
      />
      <path
        d="M10.0293 15.9258C11.1166 15.9258 11.998 15.0443 11.998 13.957C11.998 12.8697 11.1166 11.9883 10.0293 11.9883C8.94199 11.9883 8.06055 12.8697 8.06055 13.957C8.06055 15.0443 8.94199 15.9258 10.0293 15.9258Z"
        fill="url(#paint8_radial_4706_230590)"
      />
      <path
        d="M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z"
        fill="url(#paint9_radial_4706_230590)"
      />
      <path
        d="M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z"
        fill="url(#paint10_radial_4706_230590)"
      />
      <path
        d="M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z"
        fill="url(#paint11_radial_4706_230590)"
      />
      <path
        d="M10.6336 12.8801C9.43397 12.9785 8.86796 14.9358 10.2098 15.3242C11.7148 15.7601 14.0969 15.9221 14.9715 15.424C15.8461 14.9259 16.009 13.4433 14.8492 13.0824C13.6894 12.7214 11.8332 12.7817 10.6336 12.8801Z"
        fill="url(#paint12_radial_4706_230590)"
      />
      <path
        d="M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z"
        fill="url(#paint13_radial_4706_230590)"
      />
      <path
        d="M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z"
        fill="url(#paint14_radial_4706_230590)"
        fillOpacity="0.7"
      />
      <path
        d="M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z"
        fill="url(#paint15_radial_4706_230590)"
        fillOpacity="0.4"
      />
      <path
        opacity="0.7"
        d="M14.064 8.9748C13.8965 8.9748 11.8082 8.98758 11.3539 8.50399C10.4785 7.57196 11.8723 5.34422 11.2676 3.58368C10.5516 1.49891 8.18945 1.82157 8.29258 4.04618C8.37617 5.8536 7.58633 6.98446 6.74336 7.70204C6.45273 7.9493 5.99766 8.40282 5.56445 9.0161C8.05234 10.8723 10.7563 10.5842 12.3016 9.67718L14.064 8.9748Z"
        fill="url(#paint16_radial_4706_230590)"
        fillOpacity="0.8"
      />
      <path
        d="M10.3672 12.3086C11.4545 12.3086 12.3359 11.4272 12.3359 10.3398C12.3359 9.25253 11.4545 8.37109 10.3672 8.37109C9.27988 8.37109 8.39844 9.25253 8.39844 10.3398C8.39844 11.4272 9.27988 12.3086 10.3672 12.3086Z"
        fill="url(#paint17_radial_4706_230590)"
      />
      <path
        d="M9.80762 14.0586C10.8949 14.0586 11.7764 13.1772 11.7764 12.0898C11.7764 11.0025 10.8949 10.1211 9.80762 10.1211C8.72031 10.1211 7.83887 11.0025 7.83887 12.0898C7.83887 13.1772 8.72031 14.0586 9.80762 14.0586Z"
        fill="url(#paint18_radial_4706_230590)"
      />
      <path
        d="M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z"
        fill="url(#paint19_radial_4706_230590)"
      />
      <path
        d="M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z"
        fill="url(#paint20_radial_4706_230590)"
      />
      <path
        d="M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z"
        fill="url(#paint21_radial_4706_230590)"
      />
      <path
        d="M10.5502 10.9955C9.29473 11.1275 8.72832 12.9462 10.117 13.4395C11.8334 14.0492 14.558 14.062 15.4553 13.5643C16.3525 13.0669 16.5182 11.5843 15.3283 11.2223C14.1385 10.8602 11.7775 10.8664 10.5502 10.9955Z"
        fill="url(#paint22_radial_4706_230590)"
      />
      <path
        d="M11.1526 9.21806C9.75139 9.33885 9.3401 10.8579 10.7273 11.369C12.3968 11.9842 14.3499 11.7278 15.2582 11.3551C16.196 10.9704 16.324 9.38253 15.1643 9.02158C14.5241 8.82206 13.7546 9.02156 12.9349 9.09966C12.2144 9.16833 11.7536 9.16626 11.1526 9.21806Z"
        fill="url(#paint23_radial_4706_230590)"
      />
      <path
        d="M10.9786 9.24559C9.85384 9.34003 9.31932 10.7795 10.7271 11.3692C12.3966 11.9843 14.3497 11.7279 15.2579 11.3553C16.1958 10.9705 16.3238 9.37337 15.164 9.01242C14.5477 8.82034 13.7977 8.98057 13.0124 9.0905C12.3228 9.15723 11.535 9.15857 10.9786 9.24559Z"
        fill="url(#paint24_radial_4706_230590)"
      />
      <defs>
        <filter
          id="filter0_f_4706_230590"
          x="5.4082"
          y="9.01855"
          width="6.6416"
          height="7.57227"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.136719"
            result="effect1_foregroundBlur_4706_230590"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.7215 3.51213) scale(14.3293)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FFB100" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.4649 11.796) rotate(-160.304) scale(7.1343 10.8298)"
        >
          <stop offset="0.564882" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="1" stopColor="#FF8E00" stopOpacity="0.85" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.9823 13.0706) rotate(178.409) scale(4.42237 5.48846)"
        >
          <stop offset="0.154202" stopColor="#C62400" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.1101 15.5812) rotate(-12.8877) scale(1.80892)"
        >
          <stop stopColor="#A80000" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.4441 15.7775) rotate(-178.53) scale(3.60816 1.60209)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.8888 15.1686) rotate(173.738) scale(3.79489 1.3501)"
        >
          <stop offset="0.369792" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.2216 15.2703) rotate(-177.163) scale(3.30407 1.5915)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.6134 15.1206) scale(4.42617 4.14385)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0407 13.8467) rotate(10.64) scale(2.08594)"
        >
          <stop stopColor="#A80000" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.0107 14.1163) rotate(-179.036) scale(4.46632 2.00717)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.1542 13.2507) rotate(175.625) scale(4.2552 1.51385)"
        >
          <stop offset="0.44" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0817 13.2178) rotate(175.362) scale(3.29965 1.44617)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2348 13.0813) scale(4.69687 4.39729)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.10904 6.14644) rotate(3.76058) scale(10.5241 17.2596)"
        >
          <stop offset="0.812811" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.959491" stopColor="#FF9C1F" stopOpacity="0.8" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.71248 5.89161) rotate(11.5806) scale(2.55984 4.45677)"
        >
          <stop stopColor="#FF8E00" stopOpacity="0.9" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.9725 7.30992) rotate(40.4094) scale(1.99766 2.74871)"
        >
          <stop stopColor="#FF8E00" stopOpacity="0.9" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.49311 8.60657) rotate(-9.90436) scale(6.91024 9.84462)"
        >
          <stop offset="0.315291" stopColor="#FFC42E" stopOpacity="0" />
          <stop offset="0.846569" stopColor="#FF7DBE" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5161 10.2673) rotate(10.2996) scale(1.94367)"
        >
          <stop stopColor="#BA4E00" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.8188 11.9796) rotate(10.64) scale(2.08594)"
        >
          <stop stopColor="#A81E00" />
          <stop offset="1" stopColor="#FFD400" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.9446 12.4781) rotate(-177.687) scale(4.54194 2.31243)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0145 11.047) rotate(172.737) scale(3.94235 1.6129)"
        >
          <stop offset="0.44" stopColor="#DA4E00" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FFE918" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.3224 11.3391) rotate(175.673) scale(3.62978 1.48502)"
        >
          <stop stopColor="#F76D42" />
          <stop offset="1" stopColor="#F7B701" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9475 11.0767) scale(4.56289 4.27185)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.5227 10.1333) rotate(-178.53) scale(4.624 2.29462)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#F7B700" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_4706_230590"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2044 9.51577) scale(4.87656 4.56552)"
        >
          <stop offset="0.79" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FF8E00" stopOpacity="0.4" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
};
